import * as React from "react";
const RefresIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.932 10.042a8 8 0 1 1-9.925-8.788c3.9-1 7.935 1.007 9.425 4.747M17 1v5h-5"
    />
  </svg>
);
export default RefresIcon;
